import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"

export function enable_bank_list(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_pay_acc/open_bank_list`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function enable_card_list(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_pay_acc/open_list`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function payAccountList(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_pay_acc/list`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function add(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_pay_acc/add`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function add_bank_card(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_pay_acc/add_bank_card`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function update(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_pay_acc/update`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_billing_details(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_pay_acc/att_billing_details`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_bank_address_details(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_pay_acc/att_bank_address_details`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function del(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_pay_acc/delete?ba_id=${params.ba_id}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function withdrawUSDC(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_pay_acc/withdraw`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// export function createApi(params) {
//     return new Promise((resolve, reject) => {
//         postJson(`${url_domain()}${url_pre()}/security/merchant_api/create`, params)
//             .then(res => {
//                 if (res.code == 0) {
//                     resolve(res.data)
//                 }
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

// export function destroyApi(params) {
//     return new Promise((resolve, reject) => {
//         postJson(`${url_domain()}${url_pre()}/security/merchant_api/destroy`, params)
//             .then(res => {
//                 if (res.code == 0) {
//                     resolve(res.data)
//                 }
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

